export default {
  en: {
    'decimalPlaces-0': { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    'decimalPlaces-1': { minimumFractionDigits: 1, maximumFractionDigits: 1 },
    'decimalPlaces-2': { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    'decimalPlaces-3': { minimumFractionDigits: 3, maximumFractionDigits: 3 }
  },
  es: {
    'decimalPlaces-0': { minimumFractionDigits: 0, maximumFractionDigits: 0 },
    'decimalPlaces-1': { minimumFractionDigits: 1, maximumFractionDigits: 1 },
    'decimalPlaces-2': { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    'decimalPlaces-3': { minimumFractionDigits: 3, maximumFractionDigits: 3 }
  }
}
